import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { Link } from 'react-router';
// import { Tabs, Tab } from 'material-ui/Tabs';
import FlatButton from 'material-ui/FlatButton';
import ExitToApp from 'material-ui/svg-icons/action/exit-to-app';
import 'react-table/react-table.css';
// import styled from 'styled-components';
import { translate } from 'react-i18next';

import CommonTable from '../components/CommonTable';
import TextFilterField from '../components/filters/TextFilterField';
import EnumSelectFilterField from '../components/filters/EnumSelectFilterField';
import DateRangeFilterField from '../components/filters/DateRangeFilterField';
import { dateFromISO } from '../utils/helpers';
import { getCollectionRequestData } from '../utils/react-table-helpers';
import * as eventActions from '../redux/modules/events';
import { API_URL, ACTION_ENUMS, EVENT_SOURCE_ENUMS, EVENT_STATUS_ENUMS } from '../config';
import i18n from '../translations/i18n';

const eventSchema = eventActions.eventSchema;

/*
Styled components
 */
/* const TabsStyled = styled(Tabs)`
  display: inline-block;
  width: 300px;
  margin-right: 40px;
`;*/

const defaultProps = {
  result: {},
  events: {},
  loading: true,
};

const propTypes = {
  loading: PropTypes.bool,
  fetchEvents: PropTypes.func,
  t: PropTypes.func,
  result: PropTypes.shape({
    total: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.number),
  }),
  events: PropTypes.objectOf(
    PropTypes.shape({
      action: PropTypes.string,
      end_user___first_name: PropTypes.string,
      end_user___last_name: PropTypes.string,
      end_user___id: PropTypes.number,
      id: PropTypes.number,
      owner_full_name: PropTypes.string,
      owner___id: PropTypes.number,
      paketbox___id: PropTypes.number,
      paketbox___name: PropTypes.string,
      time_created: PropTypes.string,
    })
  ),
};

class EventList extends React.Component {
  constructor(props) {
    super(props);

    this.defaultSorting = [
      {
        id: 'id',
        desc: true,
      },
    ];

    this.state = {
      pageSize: 10,
      totalPages: -1,
      timeout: null,
      lastRequest: null,
      columnVisibility: {
        paketbox___street: true,
        paketbox___street_number: true,
        paketbox___postal_code: true,
        paketbox___place: true,

        id: true,
        paketbox___id: true,
        paketbox___name: true,
        owner___first_name: true,
        owner___last_name: true,
        time_created: true,
        time_received: true,

        source: true,
        lora_sf: false,
        lora_rssi: false,
        lora_snr: true,
        end_user___first_name: true,
        end_user___last_name: true,
        action_status: true,
        action: true,
        lora_sequence: false,
        humidity: false,
        pressure: false,
        temperature: false,
        battery: true,
      },
    };
  }

  getExportLink = () => {
    let exportQuery = {
      skip: 0,
      take: 9999,
    };

    if (this.state.lastRequest && this.state.lastRequest.filter) {
      exportQuery.filter = this.state.lastRequest.filter;
    }

    if (this.state.lastRequest && this.state.lastRequest.sort) {
      exportQuery.sort = this.state.lastRequest.sort;
    }

    exportQuery = JSON.stringify(exportQuery);
    const exportLink = `${API_URL}/exportcsv/event?query=${exportQuery}`;
    return exportLink;
  };

  handleColumnChange = (value) => {
    switch (value) {
      case 'simple':
        this.setState({
          columnVisibility: {
            paketbox___street: true,
            paketbox___street_number: true,
            paketbox___postal_code: true,
            paketbox___place: true,

            id: true,
            paketbox___id: true,
            paketbox___name: true,
            owner___first_name: true,
            owner___last_name: true,
            time_created: true,
            time_received: true,

            source: true,
            lora_sf: false,
            lora_rssi: false,
            lora_snr: false,
            end_user___first_name: true,
            end_user___last_name: true,
            action: true,
            action_status: true,
            lora_sequence: false,
            humidity: false,
            pressure: false,
            battery: false,
            temperature: false,
          },
        });
        break;
      case 'telemetry':
        this.setState({
          columnVisibility: {
            id: true,
            paketbox___id: true,
            paketbox___name: true,
            owner___first_name: true,
            owner___last_name: true,
            time_created: true,

            source: false,
            lora_sf: false,
            lora_rssi: false,
            lora_snr: false,
            end_user___first_name: false,
            end_user___last_name: false,
            action: false,
            action_status: false,
            lora_sequence: true,
            humidity: true,
            pressure: true,
            temperature: true,
            battery: true,
            time_received: true,
          },
        });
        break;
      case 'connection':
        this.setState({
          columnVisibility: {
            id: true,
            paketbox___id: true,
            paketbox___name: true,
            owner___first_name: true,
            owner___last_name: true,
            time_created: true,

            source: false,
            lora_sf: true,
            lora_rssi: true,
            lora_snr: true,
            end_user___first_name: true,
            end_user___last_name: true,
            action: true,
            action_status: true,
            lora_sequence: false,
            humidity: false,
            pressure: false,
            temperature: false,
            battery: false,
            time_received: false,
          },
        });
        break;
    }
  };

  initColumns() {
    this.columns = [
      {
        header: this.props.t('end_user_first_name'),
        show: this.state.columnVisibility.end_user___first_name,
        accessor: 'end_user___first_name',
        minWidth: 80,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField
            name="end_user___first_name"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
      },
      {
        header: this.props.t('end_user_last_name'),
        show: this.state.columnVisibility.end_user___first_name,
        accessor: 'end_user___last_name',
        minWidth: 80,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField
            name="end_user___last_name"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
      },

      {
        header: this.props.t('paketbox_owner'),
        show: this.state.columnVisibility.owner___first_name,
        accessor: 'owner___first_name',
        width: 140,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField
            name="owner___first_name"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
      },
      {
        header: this.props.t('paketbox_owner_last_name'),
        // show: this.state.columnVisibility.owner___last_name,
        accessor: 'owner___last_name',
        width: 140,
        show: false,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField
            name="owner___last_name"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
      },
      /*
          -- Address --
       */
      {
        header: this.props.t('street'),
        show: this.state.columnVisibility.paketbox___street,
        accessor: 'paketbox___street',
        filterMethod: (filter, row) =>
          row.street.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="street" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('number'),
        show: this.state.columnVisibility.paketbox___street_number,
        accessor: 'paketbox___street_number',
        filterMethod: (filter, row) =>
          row.street_number.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="street_number" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('postal_code'),
        show: this.state.columnVisibility.paketbox___postal_code,
        accessor: 'paketbox___postal_code',
        filterMethod: (filter, row) =>
          row.place.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="postal_code" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('place'),
        show: this.state.columnVisibility.paketbox___place,
        accessor: 'paketbox___place',
        filterMethod: (filter, row) =>
          row.place.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="place" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      /*
          -- Address END --
       */

      {
        header: this.props.t('action'),
        show: this.state.columnVisibility.action,
        accessor: 'action',
        render: row => this.props.t(row.value),
        filterRender: ({ filter, onFilterChange }) => (
          <EnumSelectFilterField
            values={ACTION_ENUMS}
            name="action"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          operator: 'eq',
        },
      },

      {
        header: this.props.t('state'),
        show: this.state.columnVisibility.action_status,
        accessor: 'action_status',
        render: obj =>
          obj.row.action_status === 'SUCCESS' ? translate('success') : translate('error'),
        width: 100,
        filterRender: ({ filter, onFilterChange }) => (
          <EnumSelectFilterField
            values={EVENT_STATUS_ENUMS}
            name="source"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          operator: 'eq',
        },
      },

      {
        header: this.props.t('paketbox_id'),
        show: this.state.columnVisibility.paketbox___id,
        accessor: 'paketbox___id',
        className: 'centerAlign',
        width: 60,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField
            type="number"
            name="paketbox___id"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          filterTransform: value => parseInt(value, 10),
          operator: 'eq',
        },
      },
      {
        header: this.props.t('paketbox'),
        show: this.state.columnVisibility.paketbox___name,
        accessor: 'paketbox___name',
        className: 'centerAlign',
        render: obj => (
          <Link to={`/packetboxes/modify/${obj.row.paketbox___id}`}>{obj.row.paketbox___name}</Link>
        ),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="paketbox___name" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_sequence'),
        show: this.state.columnVisibility.lora_sequence,
        accessor: 'lora_sequence',
        className: 'centerAlign',
        width: 140,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora_sequence" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_rssi'),
        show: this.state.columnVisibility.lora_rssi,
        accessor: 'lora_rssi',
        className: 'centerAlign',
        width: 80,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora_rssi" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_sf'),
        show: this.state.columnVisibility.lora_sf,
        accessor: 'lora_sf',
        className: 'centerAlign',
        width: 140,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora_sf" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_signal_strength'),
        show: this.state.columnVisibility.lora_snr,
        accessor: 'lora_snr',
        className: 'centerAlign',
        width: 80,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora_snr" filter={filter} onFilterChange={onFilterChange} />
        ),
        apiRequest: {
          filterTransform: value => parseFloat(value, 10),
          operator: 'eq',
        },
      },
      {
        header: this.props.t('humidity'),
        show: this.state.columnVisibility.humidity,
        accessor: 'humidity',
        width: 100,
        render: row => (row.value || row.value === 0 ? `${row.value}%` : '-'),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="humidity" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('pressure'),
        show: this.state.columnVisibility.pressure,
        accessor: 'pressure',
        width: 100,
        render: row => (row.value || row.value === 0 ? `${row.value} hPa` : '-'),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="pressure" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('temperature'),
        show: this.state.columnVisibility.temperature,
        accessor: 'temperature',
        render: row => (row.value || row.value === 0 ? `${row.value} °C` : '-'),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="temperature" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('battery'),
        show: this.state.columnVisibility.battery,
        accessor: 'battery',
        width: 100,
        render: row => (row.value || row.value === 0 ? `${row.value}V` : '-'),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="battery" filter={filter} onFilterChange={onFilterChange} />
        ),
        apiRequest: {
          filterTransform: value => parseFloat(value, 10),
          operator: 'eq',
        },
      },
      {
        header: this.props.t('fw_version'),
        accessor: 'version',
        className: 'centerAlign',
        hideFilter: true,
        filterMethod: (filter, row) =>
          row.version === undefined || row.version === null ? null : row.version.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="version" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('time_received'),
        show: this.state.columnVisibility.time_received,
        accessor: 'time_received',
        minWidth: 200,
        width: 200,
        render: row => dateFromISO(row.value),
        filterRender: ({ filter, onFilterChange }) => (
          <DateRangeFilterField
            name="time_received"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          betweenDates: true,
        },
      },
      {
        header: this.props.t('time_created'),
        show: this.state.columnVisibility.time_created,
        accessor: 'time_created',
        minWidth: 200,
        width: 200,
        render: row => dateFromISO(row.value),
        filterRender: ({ filter, onFilterChange }) => (
          <DateRangeFilterField
            name="time_created"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          betweenDates: true,
        },
      },

      {
        header: this.props.t('source'),
        show: this.state.columnVisibility.source,
        accessor: 'lora_sequence',
        render: obj => (obj.row.lora_sequence === null ? 'App' : 'LoRa'),
        width: 100,
        filterRender: ({ filter, onFilterChange }) => (
          <EnumSelectFilterField
            values={EVENT_SOURCE_ENUMS}
            name="source"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          filterTransform: value => (value === 'LORA' ? 0 : null),
          operator: value => (value === 0 ? 'isnotnull' : 'isnull'),
        },
      },

      {
        header: this.props.t('id'),
        accessor: 'id',
        show: this.state.columnVisibility.id,
        className: 'centerAlign',
        width: 60,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField
            type="number"
            name="id"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          filterTransform: value => parseInt(value, 10),
          operator: 'eq',
        },
      },
    ];
  }

  fetchData = (state) => {
    console.log('state: ', state);
    const request = getCollectionRequestData(state);
    this.setState({ pageSize: state.pageSize, lastRequest: request });

    clearTimeout(this.state.timeout);
    const timeout = setTimeout(() => {
      this.props.fetchEvents(request);
    }, 300);

    this.setState({ timeout });
  };

  render() {
    this.initColumns();

    let data = [];
    let totalPages = -1;

    if (this.props.result) {
      for (var key in this.props.events) {
        let version = null;
        if (this.props.events[key].versionMajor !== null &&
          this.props.events[key].versionMinor !== null &&
          this.props.events[key].versionPatch !== null &&
          this.props.events[key].versionBuild !== null) {
            version = this.props.events[key].versionMajor + '.' + this.props.events[key].versionMinor + '.' + this.props.events[key].versionPatch + '.' + this.props.events[key].versionBuild
            this.props.events[key].version = version;
          }
        this.props.events[key].version = version;
      }

      if (this.props.result.data.length > 0) {
        const denormalized = denormalize(
          this.props.result,
          { data: [eventSchema] },
          { events: this.props.events }
        );

        data = denormalized.data;
      }

      if (this.props.result.total) {
        totalPages = Math.ceil(this.props.result.total / this.state.pageSize);
      }
    }

    const exportButton = (
      <FlatButton
        href={this.getExportLink()}
        label={this.props.t('export')}
        target="_blank"
        icon={<ExitToApp />}
      />
    );

    /* const tabs = (
      <TabsStyled onChange={this.handleColumnChange}>
        <Tab value="simple" label={this.props.t('simple')} />
        <Tab value="telemetry" label={this.props.t('telemetry')} />
        <Tab value="connection" label={this.props.t('connection')} />
      </TabsStyled>
    );*/

    return (
      <CommonTable
        title={this.props.t('event_list')}
        rightComponent={
          <div>
            {/* tabs*/}
            {exportButton}
          </div>
        }
        data={data}
        pages={totalPages}
        defaultSorting={this.defaultSorting}
        manual
        onChange={this.fetchData}
        loading={this.props.loading}
        columns={this.columns}
      />
    );
  }
}

EventList.defaultProps = defaultProps;
EventList.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.events.fetching,
    events: state.events.entities,
    result: state.events.result,
  };
}

const extended = translate(['translations'], { i18n })(EventList);
export default connect(mapStateToProps, eventActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/EventList.js